export const PROVINCE_LIST_ACTION = "PROVINCE_LIST_ACTION";
export const PROVINCE_LIST_SUCCESS = "PROVINCE_LIST_SUCCESS";
export const PROVINCE_LIST_FAIL = "PROVINCE_LIST_FAIL";